import {Injectable} from '@angular/core';
import {Observable, throwError} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {catchError} from 'rxjs/operators';
import {environment} from '../../environments/environment';
import {FicheIntervention} from 'app/models/ficheIntervention.model';
import {PhotoLieu} from '../models/photoLieu.model';
import {WorkOrder} from '../models/workOrder.model';

@Injectable({
    providedIn: 'root'
})
export class PhotoService {
    private API_URL = environment.API_URL;
    private MODEL_URL = 'photos';

    constructor(private http: HttpClient) {
    }

    store(photoLieu: PhotoLieu): Observable<PhotoLieu> {
        return this.http.post<PhotoLieu>(this.API_URL + this.MODEL_URL, photoLieu).pipe(
            catchError(err => throwError(err))
        );
    }

    delete(id: number): Observable<any> {
        return this.http.delete(this.API_URL + this.MODEL_URL + '/' + id).pipe(
            catchError(err => throwError(err))
        );
    }
}
